export const the_client_app = document.head.querySelector('meta[name="client-app"]')!.getAttribute('content');
export const the_client_version = document.head.querySelector('meta[name="client-version"]')!.getAttribute('content');
